<template>
    <div>
        <owners-form :getOwnersList="getOwnersList" ref="ownersFormModal"></owners-form>
        <add-new-law-client-form :getOwnersList="getOwnersList" ref="addNewLawClientFormModal"></add-new-law-client-form>
        <clients-reports-form ref="clientsReportsFormModal"></clients-reports-form>
        <b-row class="align-items-center">
            <b-col class="d-flex align-items-center col-lg-8">
                <div class="mr-1">
                    <label for="owner-name-input">{{ $t('others.search_name') }}</label>
                    <b-form-input size="sm" v-model="name" v-on:keyup.enter="getOwnersList()" :placeholder="$t('owners.name')" type="text" class="d-inline-block mb-2" />
                </div>
    
                <div class="mr-1">
                    <label for="owner-country-input">{{ $t('owners.country') }}</label>
                    <b-form-select id="owner-country-input" v-model="countrySelect" size="sm" value-field="id" text-field="name" :options="countryOption" class="mb-2" />
                </div>
            </b-col>
            <b-col class="d-flex justify-content-end col-lg-4">
                <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="getOwnersList()" v-on:keyup.enter="getOwnersList()">{{ $t('owners.list') }}</b-button>
                <b-button style="float:right;" class="mr-1" size="sm" variant="outline-primary" @click="addNewLawOwners(0)">{{ $t('owners.add') }}</b-button>
                <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('lawyerDailyworkReport.excel') }}</b-button>
            </b-col>
        </b-row>
        <!-- table -->
        <vue-good-table id="clientTable" ref="clientTable" :columns="columns" :rows="rows" :sort-options="{enabled: false}" :search-options="{ enabled: true, externalQuery: searchTerm}" 
        styleClass="vgt-table condensed tableSize" :select-options="{enabled: false, selectOnCheckboxOnly: true, selectionInfoClass: 'custom-class', selectionText: 'rows selected', 
        clearSelectionText: 'clear', disableSelectInfo: true, selectAllByGroup: true}" :pagination-options="{ enabled: true, perPage: pageLength}" theme="my-theme">
            <div slot="emptystate">
                {{ $t('dataTable.data_not_found') }}
            </div>
            <!-- Row: Table Labels -->
            <template slot="table-column" slot-scope="props">
                <span v-if="props.column.field === 'name'" class="text-nowrap">
                    {{ $t('owners.name') }}
                </span>
                <span v-else-if="props.column.field === 'clientAccountingList'">
                    <b-row>
                        <b-col>
                            <span v-b-popover.hover.top="$t('owners.case')" style="cursor: pointer;">
                                {{ $t('owners.dv') }}
                            </span>
                        </b-col>
                        <b-col>
                            <span v-b-popover.hover.top="$t('owners.consultancy')" style="cursor: pointer;">
                                {{ $t('owners.le') }}
                            </span>
                        </b-col>
                        <b-col>
                            <span v-b-popover.hover.top="$t('owners.duty_registration')" style="cursor: pointer;">
                                {{ $t('owners.cu') }}
                            </span>
                        </b-col>
                        <b-col>
                            <span v-b-popover.hover.top="$t('owners.stop_duty')" style="cursor: pointer;">
                                {{ $t('owners.sc') }}
                            </span>
                        </b-col>
                        <b-col>
                            <span v-b-popover.hover.top="$t('owners.detection_of_evidence')" style="cursor: pointer;">
                                {{ $t('owners.dt') }}
                            </span>
                        </b-col>
                        <b-col v-b-popover.hover.top="$t('owners.others')" style="cursor: pointer;">
                            <span>
                                {{ $t('owners.ot') }}
                            </span>
                        </b-col>
                        <b-col v-b-popover.hover.top="$t('owners.smuggling')" style="cursor: pointer;">
                            <span>
                                {{ $t('owners.as') }}
                            </span>
                        </b-col>
                    </b-row>
                </span>
                <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                    {{ $t('others.process') }}
                </span>
            </template>
            <!-- Column: Table Elements -->
            <template slot="table-row" slot-scope="props">
                <!-- Column: Client Name -->
                <span v-if="props.column.field === 'client'">
                    <b-col>
                        <b-row>
                            <span style="font-size: smaller"><b>{{ props.row.client }}</b>
                            </span>
                        </b-row>
                        <b-row v-if="props.row.clientAddress !== null">
                            <span>
                                <tr v-if="clientAddress.address !== null" style="font-size: smaller">{{ props.row.clientAddress.address}}
                                </tr>
                                <tr v-if="clientAddress.country !== null" style="font-size: smaller">{{ props.row.clientAddress.country}}
                                </tr>
                            </span>
                        </b-row>
                    </b-col>
                </span>
                <!-- Column: AccountingList -->
                <span v-else-if="props.column.field === 'clientAccountingList'">
                    <b-row>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfDV > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 1, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfDV }}</span>
                        </b-col>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfLE > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 2, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfLE }}</span>
                        </b-col>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfCU > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 3, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfCU }}</span>
                        </b-col>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfSC > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 4, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfSC }}</span>
                        </b-col>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfDT > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 5, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfDT }}</span>
                        </b-col>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfOT > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 6, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfOT }}</span>
                        </b-col>
                        <b-col>
                            <span :style="[ props.row.lawClientMatterCountInformation.countOfAS > 0 ? { 'color': '#ff9f43' } : { 'color': 'silver' }]" style="cursor: pointer;font-weight:bold" @click="showDetailList(2, 7, props.row.lawClientMatterCountInformation.lawClientId)">{{ props.row.lawClientMatterCountInformation.countOfAS }}</span>
                        </b-col>
                    </b-row>                    
                </span>
                <!-- Column: Process -->
                <span v-else-if="props.column.field === 'process'">
                    <span>
                        <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id,props.row.clientId)">
    
                            <feather-icon icon="EditIcon" />
                        </b-button>
                        <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                            <feather-icon icon="XIcon" />
                        </b-button>
                    </span>
                </span>
            </template>
            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
                <div class="d-flex justify-content-between flex-wrap">
                    <div class="d-flex align-items-center mb-0 mt-1">
                        <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ total }} {{ $t('dataTable.record') }}
                        </span>
                    </div>
                    <div>
                        <b-pagination :value="1" :total-rows="total" v-model="pageNo" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => getOwnersList()">
                            <template #prev-text>
                                <feather-icon icon="ChevronLeftIcon" size="18" />
                            </template>
                            <template #next-text>
                                <feather-icon icon="ChevronRightIcon" size="18" />
                            </template>
                        </b-pagination>
                    </div>
                </div>
            </template>
        </vue-good-table>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {
                name: "",
                countrySelect: 0,
                countryOption: [],
                total: 0,
                pageLength: 10,
                pageNo: 1,
                dir: false,
                clientAddress: '',
                columns: [
                    {
                        label: this.$t('owners.name'),
                        field: `client`,
                    },
                    {
                        field: `clientAccountingList`,
                    },
                    {
                        label: 'Process',
                        field: 'process',
                        width: '10em'
                    },
                ],
                rows: [],
                searchTerm: '',
                agentOwnerSelect: 0
            }
        },
        mounted() {
            this.getOwnersList()
        },
        methods: {
            showDetailList(clientType, lawMatterTypeId, id) {
                if(id != 0){
                    this.$refs.clientsReportsFormModal.showInfo(clientType, lawMatterTypeId, id)
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                    this.getOwnersList()
                }
            },
            async deleted(data) {
                data = { id: data.id}
                const controller = { name: 'LawClient'}
                const payload = { data: data, controller: controller}
                this.$DeleteConfirm().then(result => {
                    if (result.value) {
                        this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$DeleteAlert()
                                this.getOwnersList()
                            } else {
                                this.$WarningAlert(response.data.resultMessage)
                                this.getOwnersList()
                            }
                        })
                    }
                })
            },
            async getInfo(id,clientId) {
                this.$refs.ownersFormModal.showInfo(id,clientId)
            },
            addNewLawOwners() {
                this.$refs.addNewLawClientFormModal.showInfo(false)
            },
            getOwnersList() {
                this.rows = []
                const controller = { name: 'LawClient'}
                const data = { clientName: this.name,  pageLength: this.pageLength, pageNo: this.pageNo, isOwner: true, countryId: this.countrySelect}
                const payload = { data: data, controller: controller}
                this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.total = response.data.total
                        this.countrySelect = this.countrySelect
                        this.countryOption = response.data.countryList
                        this.countryOption.splice(0, 0, this.$nullSelected())
    
                        response.data.lawClientList.forEach(element => {
                            this.rows.push(element)
                        })
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            },
            exportExcel() {
                const controller = { name: 'LawClient', actionName: 'CanExport'}
                const data = { columnList: this.columns, DataList: this.rows}
                const payload = { data: data, controller: controller }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        this.$downloadFile("Clients", response.data.base64, 'xlsx')
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            }
        },
    }
    </script>
    
    <style lang="scss">
    .excel-css {
        float: right;
        margin-right: 1em;
        width: 9.5em;
        color: #7367f0;
        border: 1px solid #7367f0;
        background-color: transparent;
        margin-left: 1em;
        height: 2em;
        border-radius: 0.358rem;
    }
    
    [dir] .dark-layout .card {
        background-color: #252d3f !important;
        box-shadow: 0 4px 24px 0 rgb(34 41 47 / 24%) !important;
    }
    
    .custom-checkbox .custom-control-label,
    .custom-radio .custom-control-label {
        font-size: 1rem;
        position: static;
        inline-size: max-content !important;
    }
    </style>
    